import { toast } from "react-toastify";
import store from "../redux/store";

/**
 * Stop error toasts from stacking up behind the session-expired screen (SessionExpiredGate).
 *
 * The 401 interceptor no longer hangs - it rejects with a marked error - which
 * is what lets callers clear their loading state instead of rendering a blank
 * box forever. The trade-off is that ~39 components whose `catch` blocks call
 * toast.error() would now fire on an auth expiry, where the never-settling
 * promise used to keep them quiet. Patching all 39 call sites would be easy to
 * get wrong and easy to regress, so this suppresses them in one place instead.
 *
 * Only error/warning toasts are dropped, and only once the session is known to
 * be expired: the modal is already telling the user exactly what happened, so a
 * pile of "A network or server error occurred" toasts behind it is pure noise.
 * Success/info toasts are left alone - they cannot be triggered by a failed
 * request anyway.
 */
export const installExpiredSessionToastFilter = () => {
  const isExpired = () => {
    try {
      return Boolean(store.getState()?.session?.isSessionExpired);
    } catch (_) {
      return false;
    }
  };

  ["error", "warn", "warning"].forEach(level => {
    const original = toast[level];
    if (typeof original !== "function") return;
    toast[level] = (...args) => (isExpired() ? null : original.apply(toast, args));
  });
};
